import React, {useState} from "react";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import {config} from "../../config";
import {Checkbox, IconButton, ListItemText, Select} from "@mui/material";
import {RotateLeft} from "@mui/icons-material";

export const ManagerPickerMultiselect = ({fetchFunction}) => {
    const [selectedNames, setSelectedNames] = useState([]);

    const handleChange = (event) => {
        const {target: {value}} = event;
        if (value.includes('selectAll')) {
            setSelectedNames(selectedNames.length === config.managerNames.length ? [] : config.managerNames);
        } else {
            setSelectedNames(typeof value === 'string' ? value.split(',') : value);
        }
    };

    const handleReset = () => {
        setSelectedNames([]);
    };

    const handleSubmit = () => {
        fetchFunction(selectedNames);
    };

    return (
        <div style={{paddingTop: 15, paddingBottom: 15}}>
            Managers:
            <Select variant="standard" multiple value={selectedNames} onChange={handleChange}
                    style={{width: 110, height: 25, marginLeft: 10, marginRight: 10, backgroundColor: "lightgray"}}
                    renderValue={(selected) => `${selected.length} selected`}>
                <MenuItem key="selectAll" value="selectAll" style={{height: 36}}>
                    <Checkbox checked={selectedNames.length === config.managerNames.length}
                              indeterminate={selectedNames.length > 0 && selectedNames.length < config.managerNames.length}
                              style={{height: 36}}/>
                    <ListItemText primary="(All)" style={{height: 36, marginTop: 16}}/>
                </MenuItem>
                {config.managerNames.map((name) => (
                    <MenuItem key={name} value={name} style={{height: 36}}>
                        <Checkbox checked={selectedNames.includes(name)} style={{height: 36}}/>
                        <ListItemText primary={name} style={{height: 36, marginTop: 16}}/>
                    </MenuItem>
                ))}
            </Select>
            <Button variant="contained" color="primary" style={{height: 25}} onClick={handleSubmit}>Select</Button>
            <IconButton color="inherit" style={{height: 25}} onClick={handleReset}>
                <RotateLeft/>
            </IconButton>
        </div>
    );
}